import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { Button, Chip, Container } from '@/DesignSystem/Component';
import { RenderComponents } from '@/Module/Core/Component';
import { IconLatest } from '@/Module/Icon';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import { lessonSelectByTeacherIds } from '@/Module/Teacher/Store/Selector';
import { lessonTeacherNextPageAction } from '@/Module/Teacher/Store/Slice/LessonTeacherSlice';
const componentList = dynamic(() => import('./LatestLessonList/LatestLessonList'));
const componentSlider = dynamic(() => import('./LatestLessonSlider/LatestLessonSlider'));
const TeacherDetailLatestLesson: FC = () => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(lessonSelectByTeacherIds);
  const isList = useAppSelector(state => state.lessonTeacher.page === 0);
  const total = useAppSelector(state => state.lessonTeacher.total);
  const isLoading = useAppSelector(state => state.lessonTeacher.isLoading);
  const showMore = total > ids.length;
  const onNextClick = () => {
    dispatch(lessonTeacherNextPageAction());
  };
  if (!ids.length) return null;
  return <div className="border-b-4 border-l-8 border-r-4 border-t-8 border-blueFive bg-blueOne py-8" data-sentry-component="TeacherDetailLatestLesson" data-sentry-source-file="TeacherDetailLatestLesson.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="TeacherDetailLatestLesson.tsx">
        <Chip title="آخرین قسمت ها" className="mb-8 text-2xl text-blueFive" beforeIcon={<IconLatest size="middle" className="rounded-[4px] bg-blueTwo text-blueFive" />} data-sentry-element="Chip" data-sentry-source-file="TeacherDetailLatestLesson.tsx" />

        <RenderComponents DesktopComponent={isList ? componentSlider : componentList} MobileComponent={componentSlider} ids={ids} data-sentry-element="RenderComponents" data-sentry-source-file="TeacherDetailLatestLesson.tsx" />

        {showMore && <div className="mb-12 hidden justify-center lg:mb-20 lg:flex">
            <Button isLoading={isLoading} onClick={onNextClick} className="w-full md:w-auto" variant="shadow" color="orange" radius="circle" size="large" bold>
              {isList ? 'همه درس ها' : 'نمایش بیشتر'}
            </Button>
          </div>}
      </Container>
    </div>;
};
export default TeacherDetailLatestLesson;